import { get, set } from 'lodash';

import { ENTITY_TYPE, FIELD_PATHS, PersonType } from '@funnels/constants';
import { FormValuesPostProductSelect, PostProductSelectContract, RelatedParty, StoreApplicant } from '@funnels/types';

import { INITIAL_SPOUSE_RELATED_PARTY } from './initialFormValues';

export function setSpouseRelatedPartyInitialValues(formValues: FormValuesPostProductSelect) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const relatedParties = get(formValues, FIELD_PATHS.RELATED_PARTIES(), []) as RelatedParty[];
  const relatedPartiesToBeCreated: RelatedParty[] = [];
  const applicants = get(formValues, FIELD_PATHS.APPLICANTS(), []) as StoreApplicant[];

  postProductSelects
    .filter(
      (pps) =>
        get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) === ENTITY_TYPE.APPLICANT
    )
    .forEach((pps) => {
      const applicantId = get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_ID(0));
      const hasSpouseRelatedParty = relatedParties.some(
        (relatedParty) =>
          get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_APPLICANT_ID(0)) === applicantId &&
          relatedParty.type === PersonType.Spouse
      );

      // initialise related party for the Spouse if it doesn't exists yet
      if (
        !hasSpouseRelatedParty &&
        applicants.some((applicant) => get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_ID(0)) === applicantId)
      ) {
        relatedPartiesToBeCreated.push(INITIAL_SPOUSE_RELATED_PARTY(applicantId));
      }
    });

  set(formValues, FIELD_PATHS.RELATED_PARTIES(), [...relatedParties, ...relatedPartiesToBeCreated]);
}
